export default __webpack_public_path__ + "static/media/request_black.509fa44f.png";